<template>
	<BaseLayout :footer-full="true">
		<div class="container">
			<h1 class="heading-1 text-align-center mb-100 mb-200-md">$10 Reward Program</h1>
			<section class="grid-md">
				<article class="col-8-md col-offset-2-md position-relative">
					<div class="module">
						<div class="module-header">
							<h2 class="heading-5">Terms and Conditions</h2>
						</div>
						<div class="module-section">
							<p>
								You must agree to the following terms and conditions in order to receive $10 worth of
								shares of Fundrise Real Estate Interval Fund, LLC (the “Share Bonus”) when opening a
								“Qualifying New Account” (as defined below).
							</p>

							<p>
								The Share Bonus offer is only valid for selected individuals who are not currently
								invested in Fundrise, open a Qualifying New Account, and fulfill the conditions of the
								reward program. Individuals must sign up through the reward program page (or
								advertisement) to be eligible. The Share Bonus will be credited to the Qualifying New
								Account within approximately one week after all conditions are satisfied.
							</p>

							<p>
								A Qualifying New Account is (i) a new individual Fundrise account opened by you through
								the reward program page (or advertisement), and (ii) through which an initial investment
								of at least $10 is placed within 30 days. Please note, (i) the Share Bonus is not
								available to individuals who invest through an IRA, and (ii) by signing up as an
								investor on the Fundrise platform, individuals become a client of Fundrise Advisors,
								LLC. Fundrise is not responsible for incorrect entry or other failure on the part of the
								investor to meet the standards of a Qualifying New Account.
							</p>

							<p>
								The Share Bonus offer is not valid with any other share bonus offers and is
								non-transferrable. The Share Bonus offer is available to U.S. residents only. Fundrise
								Advisors, LLC reserves the right to change the offer terms or terminate this Share Bonus
								offer at any time without notice for any reason and to refuse or recover any Share Bonus
								if Fundrise Advisors, LLC determines that it was obtained under wrongful or fraudulent
								circumstances, that inaccurate or incomplete information was provided in opening the
								Qualifying New Account or connecting the bank account, that any rules or regulations
								would be violated, or that any terms of the Fundrise Client Agreement have been
								violated. The Share Bonus offer is limited to one Share Bonus per Fundrise account, with
								no more than one Fundrise account enrolled per investor. Other restrictions may apply.
							</p>

							<p>
								Consult with your tax advisor about the appropriate tax treatment for this Share Bonus
								offer and any tax implications associated with receipt of the Share Bonus before
								enrolling. Fundrise does not take responsibility for any tax related to this Share
								Bonus.
							</p>
						</div>
					</div>
				</article>
			</section>
		</div>
	</BaseLayout>
</template>

<script setup lang="ts">
import { useHead } from '@unhead/vue';

const title = '$10 Reward Program Terms and Conditions';

useHead({
	title: '$10 Reward Program Terms and Conditions',
	meta: [
		{ property: 'og:title', content: title },
		{ name: 'description', content: title },
		{ property: 'og:description', content: title }
	]
});
</script>
